import { render, staticRenderFns } from "./UserInfoPrivacyEn.vue?vue&type=template&id=6a69b980&scoped=true&"
import script from "./UserInfoPrivacyEn.vue?vue&type=script&lang=js&"
export * from "./UserInfoPrivacyEn.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoPrivacyEn.vue?vue&type=style&index=0&id=6a69b980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69b980",
  null
  
)

export default component.exports